<template>
  <div class="share-menu" ref="raiz">
    <button
      type="button"
      class="share-menu__btn"
      :class="{ 'share-menu__btn--open': abierto }"
      :title="titulo"
      :aria-label="titulo"
      :aria-expanded="abierto ? 'true' : 'false'"
      @click.stop="alternar"
    >
      <i class="fa-regular fa-arrow-up-from-bracket"></i>
    </button>
    <div class="share-menu__panel" v-if="abierto">
      <div class="share-menu__head">
        <span class="share-menu__title">{{ titulo }}</span>
        <button
          type="button"
          class="share-menu__close"
          :aria-label="$func.parseIso('close')"
          @click="cerrar"
        >
          <i class="fa-regular fa-xmark"></i>
        </button>
      </div>
      <input
        ref="input"
        class="share-menu__input"
        type="text"
        readonly
        :value="link"
        @focus="$event.target.select()"
      />
      <button type="button" class="share-menu__copy" @click="copiar">
        <i class="fa-regular" :class="copiado ? 'fa-check' : 'fa-link'"></i>
        {{ $func.parseIso(copiado ? "linkCopiedShort" : "copyLink") }}
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Ícono de compartir con una pestañita que muestra el link y lo copia.
 * `obtenerLink` se llama al abrir, para que el link salga con la búsqueda de ese momento.
 */
export default {
  props: {
    obtenerLink: { type: Function, required: true },
    titulo: { type: String, default: "" },
  },
  data() {
    return {
      abierto: false,
      copiado: false,
      link: "",
    };
  },
  beforeDestroy() {
    this.quitarEscuchas();
  },
  methods: {
    alternar() {
      if (this.abierto) return this.cerrar();
      this.link = this.obtenerLink();
      this.copiado = false;
      this.abierto = true;
      document.addEventListener("click", this.clickFuera);
      document.addEventListener("keydown", this.teclaEsc);
    },
    cerrar() {
      this.abierto = false;
      this.quitarEscuchas();
    },
    quitarEscuchas() {
      document.removeEventListener("click", this.clickFuera);
      document.removeEventListener("keydown", this.teclaEsc);
    },
    clickFuera(e) {
      if (!this.$refs.raiz?.contains(e.target)) this.cerrar();
    },
    teclaEsc(e) {
      if (e.key === "Escape") this.cerrar();
    },
    async copiar() {
      try {
        await navigator.clipboard.writeText(this.link);
        this.copiado = true;
      } catch (error) {
        // Navegadores sin portapapeles (http o versiones viejas): copiar desde el campo
        const input = this.$refs.input;
        input.focus();
        input.select();
        this.copiado = document.execCommand("copy");
      }
    },
  },
};
</script>

<style>
.share-menu {
  position: relative;
  display: inline-flex;
}
.share-menu__btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid #0472aa;
  background: #fff;
  color: #0472aa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.share-menu__btn:hover,
.share-menu__btn--open {
  background: #eaf4fa;
}
.share-menu__panel {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  z-index: 30;
  width: 300px;
  max-width: calc(100vw - 32px);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.share-menu__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.share-menu__title {
  font-weight: 700;
  font-size: 13px;
  color: #00527c;
}
.share-menu__close {
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  font-size: 15px;
  color: #6b7280;
  cursor: pointer;
}
.share-menu__close:hover {
  color: #1a1a2e;
}
.share-menu__input {
  width: 100%;
  height: 36px;
  border: 1.5px solid #dde3ea;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  color: #1a1a2e;
  background: #f7f8fa;
}
.share-menu__copy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  border: none;
  border-radius: 6px;
  background: #0472aa;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}
.share-menu__copy:hover {
  background: #00527c;
}
@media (max-width: 767px) {
  /* En celular el ícono queda a la izquierda: la pestañita abre hacia la derecha */
  .share-menu__panel {
    right: auto;
    left: 0;
  }
}
</style>
